var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKeyMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.912 15.2909C25.448 12.7539 29.567 12.7539 32.104 15.2909C34.641 17.8269 34.641 21.9459 32.104 24.4829C29.567 27.0199 25.448 27.0199 22.912 24.4829C20.375 21.9459 20.375 17.8269 22.912 15.2909ZM24.909 17.5429C23.668 18.9159 23.71 21.0389 25.033 22.3619C26.399 23.7279 28.617 23.7279 29.983 22.3619C31.349 20.9959 31.349 18.7779 29.983 17.4119C28.617 16.0459 26.399 16.0459 25.033 17.4119L24.909 17.5429Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5652 22.709C22.5652 22.709 16.8512 28.422 14.4332 30.841C13.8472 31.426 13.8472 32.376 14.4332 32.962L14.4342 32.963C15.0192 33.548 15.9682 33.548 16.5532 32.963C18.9702 30.546 24.6862 24.83 24.6862 24.83L22.5652 22.709Z",
    fill: "#E7E7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5614 27.833L16.0264 31.369C16.0264 31.369 18.0874 33.43 19.0624 34.405C19.3384 34.681 19.7854 34.681 20.0614 34.405C20.7344 33.732 21.9254 32.541 22.5984 31.868C22.8734 31.592 22.8734 31.145 22.5984 30.869C21.6234 29.895 19.5614 27.833 19.5614 27.833Z",
    fill: "#E7E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyMenu);
export default __webpack_public_path__ + "static/media/icon_key_menu.aac5515c026de98306c0a81d00725092.svg";
export { ForwardRef as ReactComponent };